// Application
import { useAccountContext, useApp, useLoginContext } from 'context'
import { useAccountService } from 'services/account'
import { PatientInfoInput } from 'typings/signup'
import { CreatePatientInput } from 'typings/account'

const LIVIA_LS_KEY = '@Livia'

export const useActiveCIPOrphanHook = () => {
    const {
        state,
        operations: {
            setPersonalData,
            setSubmitting,
            setPassword,
            setBiologicalSex,
            setContact,
            resetAccountState,
            setPhone,
            setTokenCIP,
            setAccount,
        },
    } = useAccountContext()

    const {
        operations: { signOut },
    } = useLoginContext()

    const {
        createLogin,
        viewerSearchLoginByCPF,
        verifyPreUserRegistration,
        resendToken,
        associateCip,
        ...service
    } = useAccountService()
    const { openHelpModal, openToast, openAccountExistsModal } = useApp()

    const confirmToken = async (token: string) => {
        const { cpf: userName, password } = state
        const dataConfirmation = {
            userName,
            token,
            password,
        }
        const data = await service.confirmToken(dataConfirmation)

        if (!data || !data.confirmToken || !data.confirmToken.authentication) {
            return false
        }

        localStorage.setItem(
            LIVIA_LS_KEY,
            JSON.stringify({
                token: data.confirmToken.authentication.access_token,
                refreshToken: data.confirmToken.authentication.refresh_token,
            }),
        )

        return true
    }

    const viewerSearchLogin = async (username: string) => {
        try {
            await viewerSearchLoginByCPF(username)
            return true
        } catch (error) {
            return false
        }
    }

    const viewerSearchPatient = async (patient: PatientInfoInput) => {
        const { viewerSearch } = await verifyPreUserRegistration(patient)

        return viewerSearch
    }

    const createPatientAccount = async (patient: CreatePatientInput) => {
        const data = await service.createPatientAccount(patient)

        return data
    }

    return {
        ...state,
        setPersonalData,
        setPassword,
        setContact,
        setSubmitting,
        setAccount,
        setPhone,
        viewerSearchLoginByCPF,
        verifyPreUserRegistration,
        confirmToken,
        openHelpModal,
        openToast,
        viewerSearchPatient,
        viewerSearchLogin,
        createLogin,
        resendToken,
        resetAccountState,
        createPatientAccount,
        signOut,
        setTokenCIP,
        setBiologicalSex,
        openAccountExistsModal,
        associateCip,
    }
}
